<template>
  <div class="welcomeContainer" :class="{ mobileWelcomeContainer: isMobileSized }">
    <v-row
      class="welcomeContent justify-space-between"
      :class="{ mobileWelcomeContent: isMobileSized }"
    >
      <v-col
        :cols="isMobileSized ? 12 : 5"
        class="welcomeHeader d-flex px-10"
        :class="isMobileSized ? '' : 'align-center'"
        :style="isMobileSized ? '' : 'height:100vh;'"
      >
        <div :class="{ mobileDisplayContainer: isMobileSized }">
          <div class="text-h2 welcomeTitle" :class="{ mobileTitle: isMobileSized }">
            Welcome to Adacado
          </div>
          <p
            class="largeDescriptionText"
            :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
          >
            Start your advertising journey with Adacado, the Do-It-Yourself advertising platform
            where simplicity meets innovation.
          </p>
          <p v-if="!isMobileSized" class="largeDescriptionText">
            Unleash the power to effortlessly craft compelling campaigns while saving yourself time,
            money, and headaches along the way.
          </p>
          <!-- uncomment this once we actually have a video -->
          <!-- <div class="caption" style="color:#9E9E9E">
            Watch demo (2 minutes)
          </div> -->
          <div v-if="showButton" :class="{ mobileServeMyAdsIntroButtonDisplay: isMobileSized }">
            <v-btn
              class="my-2"
              dark
              color="orange"
              :style="isMobileSized ? '' : 'width:100%'"
              @click="
                guibus_publish('dispatch:beacon', {
                  eventId: `welcome-intro_slide_start_button-click${
                    isMobileSized ? '-mobile' : ''
                  }`,
                })
                $emit('changeStep', 'survey')
              "
            >
              Start Serving Ads for Free</v-btn
            >
          </div>
          <div class="d-flex justify-center" :class="{ 'mt-12': !isMobileSized }">
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="my-2"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="#5e00eb"
                  @click="
                    guibus_publish('dispatch:beacon', {
                      eventId: `welcome-intro_slide_watch_video_menu-click${
                        isMobileSized ? '-mobile' : ''
                      }`,
                    })
                  "
                  :small="isMobileSized"
                >
                  <v-icon class="mr-2">mdi-video-outline</v-icon> Watch Adacado in Action</v-btn
                >
              </template>

              <v-list>
                <v-list-item v-for="(video, i) of videos" :key="`video${i}`" class="videoOption">
                  <v-list-item-title @click="handleWatchVideoClick(video)">{{
                    video.title
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-col>
      <v-col
        class="d-flex align-center"
        :class="isMobileSized ? 'px-4' : 'px-10'"
        style="background-color: rgb(94, 0, 235);"
        :style="isMobileSized ? 'justify-content: center;' : 'height:100vh;'"
      >
        <div
          class="quickStartSteps"
          :class="{ mobileSteps: isMobileSized }"
          :style="{ marginTop: featureStepsTopMargin + 'px' }"
        >
          <v-row class="featureRow" :class="{ featureRowMobile: isMobileSized }">
            <v-col cols="7" class="d-flex justify-center">
              <img
                src="../../assets/welcome.jpg"
                alt="Adacado"
                class="featurePreviewImage"
                style="align-self: center;"
              />
            </v-col>
            <v-col
              class="ml-2 white--text font-weight-bold featurePreviewText"
              :class="{ mobileText: isMobileSized }"
            >
              {{
                isMobileSized
                  ? '1. Choose a solution.'
                  : '1. Choose a solution based on your goals and objectives.'
              }}
            </v-col>
          </v-row>
          <v-row class="featureRow" :class="{ featureRowMobile: isMobileSized }">
            <v-col cols="7" class="d-flex justify-center">
              <img
                src="../../assets/welcome-2.jpg"
                alt="Adacado"
                class="featurePreviewImage"
                style="align-self: center;"
              />
            </v-col>
            <v-col
              class="ml-2 white--text font-weight-bold featurePreviewText"
              :class="{ mobileText: isMobileSized }"
            >
              {{
                isMobileSized
                  ? '2. Customize your ads.'
                  : '2. Adjust your ads to include your logo, promotional text, images, and call to action.'
              }}</v-col
            >
          </v-row>
          <v-row class="featureRow" :class="{ featureRowMobile: isMobileSized }">
            <v-col cols="7" class="d-flex justify-center">
              <img
                src="../../assets/welcome-3.jpg"
                alt="Adacado"
                class="featurePreviewImage"
                style="align-self: center;"
              />
            </v-col>
            <v-col
              class="ml-2 white--text font-weight-bold featurePreviewText"
              :class="{ mobileText: isMobileSized }"
              >3. Publish your ads to the web.</v-col
            >
          </v-row>
        </div>
      </v-col>
    </v-row>
    <!-- overview video(s) modal -->
    <v-dialog v-model="showVideo" max-width="1000" @click:outside="showVideo = false">
      <v-card v-if="showVideo">
        <v-card-title class="headline">{{ selectedVideo.title }}</v-card-title>
        <v-card-text>
          Turn on your volume. Click the bottom right corner of the video to view in full screen.
        </v-card-text>
        <v-card-text class="d-flex justify-center">
          <iframe
            width="900"
            :height="isMobileSized ? 250 : 506"
            :src="overviewVideoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showVideo = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  props: {
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showButton: false,
      showVideo: false,
      overviewVideoUrl: '',
      videos: [
        {
          title: 'On-Boarding Overview',
          name: 'onboarding',
          id: 'pDtQd6hHxh0',
        },
        {
          title: 'Highlights for Advertising Agencies',
          name: 'agency',
          id: 'Oz4Eu733ehA',
        },
      ],
      selectedVideo: undefined,
    }
  },
  mounted() {
    setTimeout(() => {
      this.showButton = true
    }, 1200)
  },
  computed: {
    featureStepsTopMargin() {
      if (this.isMobileSized && window.innerHeight > 775) {
        return (window.innerHeight - 775) / 3
      }
      return 0
    },
  },
  methods: {
    handleWatchVideoClick(videoSelection) {
      this.selectedVideo = videoSelection
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-intro_slide_watch_video_menu_${videoSelection.name}-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.showVideo = true
      this.overviewVideoUrl = `https://www.youtube.com/embed/${videoSelection.id}?autoplay=1`
    },
  },
}
</script>

<style lang="scss" scoped>
.welcomeContainer {
  width: 100vw;
  margin-top: 0px;
  &.mobileWelcomeContainer {
    height: calc(100vh - 229px);
    overflow: auto;
    margin-top: 82px;
  }
  .welcomeContent {
    display: flex;
    height: 100vh;
    position: relative;
    width: 100%;
    margin: auto;
    align-items: center;
    &.mobileWelcomeContent {
      height: unset;
    }
    .welcomeBox {
      display: flex;
      padding: 20px;
      width: 1600px;
      justify-content: space-between;
      align-items: center;
    }
  }
}
.featurePreviewText {
  align-self: center;
  &.mobileText {
    font-size: 15px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}
.featurePreviewImage {
  width: 90%;
  justify-self: center;
  border-radius: 15px;
  max-height: 270px;
  max-width: 476px;
}
.welcomeHeader {
  .welcomeTitle {
    font-family: 'Roboto' !important;
    font-weight: bold;
    &.mobileTitle {
      font-size: 1.8rem !important;
    }
  }
}
.quickStartSteps {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.mobileDisplayContainer {
  position: relative;
}
.mobileServeMyAdsIntroButtonDisplay {
  position: fixed;
  bottom: 85px;
  left: 0;
  width: 100%;
  display: flex;
  z-index: 10;
  button {
    width: 92%;
    margin: 0 auto;
  }
}
.featureRow {
  align-items: center;
  &.featureRowMobile {
    margin-bottom: 10px;
  }
}
.videoOption {
  cursor: pointer;
  &:hover {
    background-color: #80808038;
  }
}
</style>
